import * as React from 'react'
import { FC, useState, useCallback } from 'react'

import { AddPaymentMethodDialog } from '../AddPaymentMethodDialog/AddPaymentMethodDialog'
import { ENTITY_TYPES } from '@sales-center/common'
import { SideDrawer } from '@sales-center/components'
import { TableWrapper } from './Table/TableWrapper'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  locationId: string
  billToId: string
  onClose: () => void
  open: boolean
  canUpdate: boolean
}

export const ViewPaymentMethodsDrawer: FC<Props> = (props) => {
  const {
    entityId,
    entityType,
    locationId,
    billToId,
    onClose,
    open,
    canUpdate,
  } = props

  const [addIsOpen, setAddIsOpen] = useState<boolean>(false)

  const openAddPaymentDialog = useCallback(
    () => canUpdate && setAddIsOpen(true),
    [canUpdate],
  )

  const closeAddPaymentDialog = useCallback(() => setAddIsOpen(false), [])

  return (
    <SideDrawer
      onClose={onClose}
      open={open}
      title={`Payment Methods`}
      width={650}
    >
      <TableWrapper
        billToId={billToId}
        locationId={locationId}
        entityType={entityType}
        handleAddPayment={openAddPaymentDialog}
        canUpdate={canUpdate}
      />
      <AddPaymentMethodDialog
        entityId={entityId}
        entityType={entityType}
        locationId={locationId}
        onClose={closeAddPaymentDialog}
        open={addIsOpen}
      />
    </SideDrawer>
  )
}

ViewPaymentMethodsDrawer.displayName = 'ViewPaymentMethodsDrawer'
